import { storage } from "lib";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import SocialSecurityContributionView from "../page/SocialSecurityContributionView";

import useOptions from "features/masterData/hooks/useOptions";
import SocialSecurityContributionEdit from "../page/SocialSecurityContributionEdit";
import { Modal } from "antd";
// import { } from "../schemas/socialSecurityContributionSchema";

const PAGE_TYPE = {
  view: "view",
  edit: "edit",
  main: "main",
};

function useSocialSecurityContribution() {
  const [selectedCompany, setCompany] = useState(1);
  const [selectedMenu, setMenu] = useState("socialSecurityContribution");
  const [pageType, setPageType] = useState(PAGE_TYPE.view);
  const { t, i18n } = useTranslation();
  const [lang, setLang] = useState("en");
  const [node, setNode] = useState([]);
  const currentCompany = useSelector((state) => state.company.currentCompany);

  const onEdit = useCallback(() => {
    setPageType(PAGE_TYPE.edit);
  }, [setPageType]);

  const onCancel = useCallback((value) => {
    if (value == true) { setPageType(PAGE_TYPE.view); } else {
      Modal.confirm({
        title: t('dialog.confirmation.header'),
        content: (
          <>
            <p>{t('are-you-sure-confirm-to-cancel')}</p>
          </>
        ),
        onOk() {
          setPageType(PAGE_TYPE.view);
        },
        okText: t('reset.confirm'),
        cancelText: t('action.cancel'),
      });

    }

  }, [setPageType]);

  const {
    acountTypeOption = [],
    getSocialSecurityBranchOption,
    getSetAcountTypeOption,
  } = useOptions();

  const onView = useCallback(() => {
    setPageType(PAGE_TYPE.view);
  }, [setPageType]);

  const handleChange = useCallback(
    (value) => {
      setCompany(value);
    },
    [setCompany]
  );

  const getPage = useCallback(() => {
    switch (selectedMenu) {
      case "socialSecurityContribution":
        return pageType === PAGE_TYPE.view ? (
          <SocialSecurityContributionView onEdit={onEdit} />
        ) : (
          <SocialSecurityContributionEdit onCancel={onCancel} />
        );
      default:
        return <div />;
    }
  }, [
    selectedMenu,
    node,
    acountTypeOption,
    pageType,
    onCancel,
  ]);

  useEffect(() => {
    setLang(i18n.language);
  }, [i18n.language, setLang]);

  useEffect(() => {
    if (currentCompany != null) {
      getSocialSecurityBranchOption();
    }
  }, [currentCompany, getSocialSecurityBranchOption]);

  useEffect(() => {
    if (currentCompany != null) {
      getSetAcountTypeOption();
    }
  }, [currentCompany, getSetAcountTypeOption]);

  return {
    pageType,
    selectedCompany,
    selectedMenu,
    onView,
    onEdit,
    handleChange,
    getPage,
  };
}

export default useSocialSecurityContribution;
